import React, { useEffect, useState } from 'react'
import {
  Table,
  Button,
  Modal,
  Input,
  Grid,
  Checkbox,
  Form,
  Header,
  Icon,
  Popup,
  Dropdown,
  PopupContent,
  List,
  Segment,
} from 'semantic-ui-react'
import MickeyTable from '../../../components/MickeyTable/MickeyTable'
import { hasPermission, hasPricing } from '../../../lib/utils/utils'
import { formatTotalPrice } from '../../../lib/utils/utils'
import { toast } from 'react-toastify'
import './AdminOrder.css'
import ConfirmationModal from '../../../components/ConfirmationModal'
import env from '../../../env'
import _ from 'underscore'
import AdminOrderItemsRow from './AdminOrderItemsRow'
import useAxios from '../../../lib/auth/useAxios'
import MickeyDropdown from '../../../components/MickeyDropdown/MickeyDropdown'
import OrderItemDetailTwo from '../../../components/OrderItemDetail/OrderItemDetailTwo'
import { useNavigate, useParams } from 'react-router-dom'
import MickeyPlaceholder from '../../../components/Placeholder/Placeholder'
import { TextAlignLeft } from 'phosphor-react'
import {
  CaretDown,
  CaretRight,
  PaperPlaneTilt,
  Plus,
  Trash,
} from 'phosphor-react'
import { useSelector } from 'react-redux'
import AddPurchaseOrder from '../../../components/PurchaseOrders/AddPurchaseOrder'
import AddSalesOrder from '../../../components/SalesOrders/AddSalesOrder'

function AdminOrderMaterialsList(props) {
  const tenant = useSelector((state) => {
    return state?.globals?.tenant
  })
  const axios = useAxios()
  const user = useSelector((state) => state.user.user)
  const { orderId } = useParams()
  const navigate = useNavigate()
  const {
    order,
    setOrder,
    orderItems,
    setOrderItems,
    reloadAdminOrder,
    setReloadAdminOrder,
    addBidOrderModal,
    setAddBidOrderModal,
    bidOrderButtonActive,
    setAddBidOrderButtonActive,
  } = props
  
  // Debug logging to see what orderItems contains
  useEffect(() => {
    console.log('AdminOrderMaterialsList - orderItems:', orderItems)
    if (orderItems && orderItems.length > 0) {
      orderItems.forEach((item, index) => {
        console.log(`OrderItem ${index}:`, {
          id: item.id,
          quantity: item.quantity,
          buyer_quantity: item.buyer_quantity,
          price: item.price,
          product_variant: item.product_variant,
          product_variant_id: item.product_variant_id
        })
      })
    }
  }, [orderItems])
  const [globalSettings, setGlobalSettings] = useState()
  const [purchaseOrder, setPurchaseOrder] = useState()
  const [salesOrder, setSalesOrder] = useState()
  const [selectedMaterials, setSelectedMaterials] = useState([])
  const [selectedOrderItems, setSelectedOrderItems] = useState([])
  const [addTruckModal, setAddTruckModal] = useState(false)
  const [addPurchaseOrderModal, setAddPurchaseOrderModal] = useState(false)
  const [numberOfTrucks, setNumberOfTrucks] = useState(1)
  const [addTruckButtonLoading, setAddTruckButtonLoading] = useState(false)
  const [archiveOrderConfirmationModel, setArchiveOrderConfirmationModel] =
    useState(false)
  const [loadingArchiveOrderItems, setLoadingArchiveOrderItems] =
    useState(false)
  const [selectedDeliveryLocationId, setSelectedDeliveryLocationId] =
    useState(null)
  const [selectedPickupLocationId, setSelectedPickupLocationId] = useState(null)
  const [selectedCargoUnitId, setSelectedCargoUnitId] = useState(null)
  const [addRFQModal, setAddRFQModal] = useState(null)
  const [selectedSuppliers, setSelectedSuppliers] = useState([])
  const [selectedBuyers, setSelectedBuyers] = useState([])
  const [rfqNumber, setRfqNumber] = useState([])
  const [addSalesOrderModal, setAddSalesOrderModal] = useState(null)
  const [addInvoiceOrderModal, setAddInvoiceOrderModal] = useState(null)
  const [selectedBidSign, setSelectedBidSign] = useState(null)
  const [selectedInvoiceMethod, setSelectedInvoiceMethod] = useState(null)
  const [invoiceNumber, setInvoiceNumber] = useState(null)
  const [invoiceShipVia, setInvoiceShipVia] = useState('')
  const [invoiceFob, setInvoiceFob] = useState('')
  const [invoiceRequisitioner, setInvoiceRequisitioner] = useState('')
  const [invoiceExpectedShipDate, setInvoiceExpectedShipDate] = useState('')
  const [invoicePaymentTerms, setInvoicePaymentTerms] = useState('')
  const [salesOrderNumber, setSalesOrderNumber] = useState(null)
  const [addOrderInfoSheetModal, setAddOrderInfoSheetModal] = useState(null)
  const [sendDocumentPopup, setSendDocumentPopup] = useState(null)
  const [reload, setReload] = useState(reloadAdminOrder)
  const [totalTake, setTotalTake] = useState(0)
  const [totalSecondaryTake, setTotalSecondaryTake] = useState(0)
  const [totalTax, setTotalTax] = useState(0)
  const [totalPrice, setTotalPrice] = useState(0)
  const [deliveredPrice, setDeliveredPrice] = useState(0)
  const [secondaryDeliveredPrice, setSecondaryDeliveredPrice] = useState(0)
  const [supplier, setSupplier] = useState(false)
  const [orderItem, setOrderItem] = useState(false)
  const [loading, setLoading] = useState(false)
  const primaryPricing = hasPricing(user, 'primary')
  const [selectAll, setSelectAll] = useState(false)
  const [locationId, setLocationId] = useState()
  const [addOrderInformationSheetModal, setAddOrderInformationSheetModal] =
    useState(false)

  const itemsHeaderRow = [
    <Checkbox
      color={'primary'}
      checked={selectAll}
      sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
      style={{ marginLeft: '30px', marginTop: '10px' }}
      onClick={(e, d) => {
        setSelectAll(!selectAll)
        let sm = []
        let sois = []
        if (!selectAll) {
          orderItems.forEach((orderItem) => {
            sm.push(orderItem?.id)
            sois.push(orderItem)
          })
          setSelectedMaterials(sm)
          setSelectedOrderItems(sois)
        } else {
          setSelectedMaterials(sm)
          setSelectedOrderItems(sois)
        }
      }}
    />,
    'Product Details',
    'Supplier',
    'Supplier Price',
    'Supplier Quantity',
    'Supplier Total',
    'Buyer Price',
    'Buyer Quantity',
    'Extended Quantity',
    'Sales Tax',
    'Buyer Total',
    'Margin',
    'Status',
  ]

  useEffect(() => {
    setSupplier(order?.supplier)
  }, [order])

  useEffect(() => {
    if (!reloadAdminOrder) {
      setLoading(true)
    }
  }, [reloadAdminOrder])

  useEffect(() => {
    let tp = 0
    let ttrucking = 0
    let ttake = 0
    let tstake = 0
    let ttax = 0
    let dp = 0
    let sdp = 0
    orderItems?.forEach((orderItem) => {
      if (displayOrderItem(orderItem)) {
        let supPrice = 0
        if (
          (!orderItem.is_credit_line_item &&
            !orderItem?.is_buyer_marketplace_fee) ||
          (order?.paid && orderItem.is_credit_line_item)
        ) {
          supPrice = orderItem.price * orderItem.quantity
          tp += supPrice
        }
        let trucking = orderItem?.trucking_price
          ? parseFloat(orderItem?.trucking_price)
          : 0
        let take = orderItem?.is_buyer_marketplace_fee
          ? parseFloat(orderItem?.buyer_marketplace_fee)
          : orderItem?.mickey_take && !orderItem?.is_credit_line_item
          ? parseFloat(orderItem?.mickey_take)
          : 0
        let secondaryTake = orderItem?.is_buyer_marketplace_fee
          ? parseFloat(orderItem?.buyer_marketplace_fee)
          : orderItem?.secondary_mickey_take && !orderItem?.is_credit_line_item
          ? parseFloat(orderItem?.secondary_mickey_take)
          : 0
        let tax = orderItem?.is_buyer_marketplace_fee
          ? parseFloat(orderItem?.buyer_marketplace_fee_tax_amount)
          : orderItem?.tax_amount
          ? parseFloat(orderItem?.tax_amount)
          : 0
        let discount = orderItem?.discount ? parseFloat(orderItem?.discount) : 0

        ttrucking += trucking
        ttake += take
        tstake += secondaryTake
        ttax += tax
        dp += supPrice - discount + trucking + take + tax
        sdp += supPrice - discount + trucking + secondaryTake + tax
      }
    })
    setTotalPrice(tp)
    setTotalTake(ttake)
    setTotalTax(ttax)
    setDeliveredPrice(dp)
    setSecondaryDeliveredPrice(sdp)
    setTotalSecondaryTake(tstake)
  }, [orderItems])

  const displayOrderItem = (orderItem) => {
    let use = true
    if (orderItem?.is_credit_line_item && orderItem.price === '0.000') {
      use = false
    }
    if (orderItem?.order?.mx_order && orderItem?.is_buyer_marketplace_fee) {
      use = false
    }
    return use
  }

  const getGlobalSettings = async () => {
    const resp = await axios.get('main/global-setting/')
    if (resp?.data?.results) {
      setGlobalSettings(resp?.data?.results[0])
    }
  }

  useEffect(() => {
    getGlobalSettings()
  }, [])

  useEffect(() => {
    setAddBidOrderButtonActive(
      !selectedMaterials || selectedMaterials?.length === 0
    )
  }, [selectedMaterials])

  async function sendRFQ(sendEmail) {
    let res = await axios.post(`/main/rfqs/`, {
      send_email: sendEmail,
      suppliers: selectedSuppliers,
      buyers: selectedBuyers,
      oi_ids: selectedMaterials,
      rfq_number: rfqNumber,
    })

    if (res.data.success) {
      if (sendEmail) {
        toast.success('RFQs Sent!')
      } else {
        toast.success('RFQs Activated!')
      }
      setAddRFQModal(false)
      setSelectedSuppliers([])
      setSelectedBuyers([])
      setRfqNumber([])
      navigate(`/portal/admin/deals/${orderId}/rfqs`)
    } else {
      if (res?.data?.error) {
        toast.error(res.data.error)
      } else {
        if (sendEmail) {
          toast.error('Error sending RFQs.')
        } else {
          toast.error('Error activating RFQs.')
        }
      }
    }
  }

  async function addTruck() {
    setAddTruckButtonLoading(true)
    if (numberOfTrucks < 1) {
      toast.error('Please Enter Valid Number of Trucks')
      setAddTruckButtonLoading(false)
      return
    }
    let addTruckOrderItems = []
    for (let orderItem of orderItems) {
      if (
        !orderItem?.is_buyer_marketplace_fee &&
        selectedMaterials.includes(orderItem?.id)
      ) {
        addTruckOrderItems.push({
          oi_id: orderItem?.id,
          oi_qty: orderItem?.selected_delivery_quantity
            ? orderItem?.selected_delivery_quantity
            : 0,
        })
      }
    }

    let res = await axios.post(`/main/cargo-transportation/`, {
      cargo_unit_id: selectedCargoUnitId,
      pickup_location_id: selectedPickupLocationId,
      delivery_location_id: selectedDeliveryLocationId,
      number_of_trucks: numberOfTrucks,
      oi_data: addTruckOrderItems,
    })
    setAddTruckButtonLoading(false)
    if (res.data.success) {
      toast.success('Truck Added!')
      navigate(`/portal/admin/deals/${orderId}/fulfillment`)
    } else {
      if (res?.data?.error) {
        toast.error(res.data.error)
      } else {
        toast.error('Error adding truck.')
      }
    }
  }

  async function invoiceOnly(sendEmail) {
    if (!invoiceNumber) {
      toast.error('Invoice number required')
      return
    }
    if (sendEmail && !order.buyer.business.contact) {
      toast.error(
        `${order.buyer.business.name} requires a contact user to send files for signature`
      )
      return
    }
    let customOrderItemRows = {}
    const orderItemIds = []
    for (let orderItem of orderItems) {
      if (
        !orderItem?.is_buyer_marketplace_fee &&
        selectedMaterials.includes(orderItem?.id)
      ) {
        if (orderItem?.buyer_quantity && orderItem?.buyer_quantity > 0) {
          customOrderItemRows[orderItem?.id] = {
            buyer_quantity: orderItem?.buyer_quantity,
            buyer_unit_id: orderItem?.buyer_unit,
            delivered_price: orderItem?.delivered_price,
          }
          orderItemIds.push(orderItem?.id)
        } else {
          toast.error('Quantity must be greater than 0')
          return
        }
      }
    }
    let res = await axios.post(`/main/sign-requests/`, {
      file_type: 'invoice',
      send_to_customer: sendEmail,
      send_invoice_to_customer: sendEmail,
      custom_order_items_rows: customOrderItemRows,
      order_item_ids: orderItemIds,
      invoice_number: invoiceNumber,
      order_id: order?.id,
      invoice_method: 'invoice_only',
      // Additional invoice document fields
      invoice_ship_via: invoiceShipVia,
      invoice_fob: invoiceFob,
      invoice_requisitioner: invoiceRequisitioner,
      invoice_expected_ship_date: invoiceExpectedShipDate,
      invoice_payment_terms: invoicePaymentTerms,
    })
    if (res?.data.success) {
      toast.success(`Invoice created and sent!`)
      setAddInvoiceOrderModal(false)
    } else if (res?.data && res?.data?.error) {
      toast.error(res?.data?.error)
    } else {
      toast.error('Error generating invoice')
    }
  }

  const addSalesOrder = async (sendEmail) => {
    if (sendEmail && !order.buyer.business.contact) {
      toast.error(
        `${order.buyer.business.name} requires a contact user to send files for signature`
      )
    } else if (!salesOrderNumber) {
      toast.error('Sales order number required')
    } else {
      let addSalesOrderOrderItems = []
      for (let orderItem of orderItems) {
        if (
          !orderItem?.is_buyer_marketplace_fee &&
          orderItem?.selected_sales_order_quantity &&
          selectedMaterials.includes(orderItem?.id) &&
          orderItem?.selected_sales_order_quantity > 0
        ) {
          addSalesOrderOrderItems.push({
            oi_id: orderItem?.id,
            quantity: orderItem?.selected_sales_order_quantity,
            buyer_uom_id: orderItem?.selected_sales_order_unit_of_measure,
            product_variant_id: orderItem?.product_variant_id,
            price: orderItem?.delivered_price,
          })
        } else if (
          !orderItem?.selected_sales_order_quantity ||
          parseFloat(orderItem?.selected_sales_order_quantity) <= 0
        ) {
          toast.error('Quantity must be greater than 0')
          return
        }
      }
      let res = await axios.post(`/main/admin-order-accounting-view/`, {
        sales_order: true,
        order_id: order?.id,
        order_items: addSalesOrderOrderItems,
        sales_order_number: salesOrderNumber,
        send_email: sendEmail,
        shipping_location_id: locationId,
      })
      if (res.data.success) {
        toast.success(
          `Sales order generation started! Please check ${globalSettings.box_sign_review_email} inbox for a Box Sign Request to complete the document.`
        )
      } else {
        toast.error('Error creating sales order')
      }
    }
  }

  function addOrderInfoSheet(send) {
    const res = axios({
      method: 'post',
      url: '/main/documents/',
      data: {
        document_type: 'Order Information Sheet',
        document_name: 'Order Information Sheet',
        order_id: order?.id,
        buyer_id: order?.buyer?.id,
        order_items: selectedMaterials,
        send_email: send,
        visibility: 'Buyer',
      },
    })
      .then((res) => {
        if (res?.data?.success) {
          setAddOrderInfoSheetModal(false)
          toast.success('Order Information Sheet Created')
          navigate(`/portal/admin/deals/${orderId}/documents`)
        } else {
          toast.error(res?.data?.error)
        }
      })
      .catch((err) => {
        console.log(err)
        toast.error(
          err?.response?.data?.detail ||
            'Error Creating Order Information Sheet'
        )
      })
  }

  async function addBidOrder(sendEmail) {
    if (sendEmail && !order?.buyer?.business?.contact) {
      toast.error(
        `${order.buyer.business.name} requires a contact user to send files for signature`
      )
      return
    }
    const orderItemIds = []
    orderItems.forEach((orderItem) => {
      if (
        !orderItem?.is_buyer_marketplace_fee &&
        selectedMaterials.includes(orderItem?.id)
      ) {
        if (!orderItem.quantity || parseFloat(orderItem.quantity) <= 0) {
          toast.error('Quantity must be greater than 0')
          return
        }
        orderItemIds.push(orderItem.id)
      }
    })
    let res = await axios.post(`/main/sign-requests/`, {
      file_type: selectedBidSign,
      send_to_customer: sendEmail,
      order_item_ids: orderItemIds,
      order_id: order?.id,
    })
    if (res?.status === 201) {
      toast.success(
        `${
          selectedBidSign === 'bid' ? 'Bid' : 'Pre bid'
        } generation started! Please check ${
          globalSettings.box_sign_review_email
        } inbox for a Box Sign Request to complete the document.`
      )
    } else {
      toast.error('Error Creating Bid Sign Request')
    }
  }

  async function archiveOrderItems() {
    setLoadingArchiveOrderItems(true)
    let resInstance = await axios.post(
      `/main/admin-order-items/bulk_archive/`,
      {
        order_item_ids: selectedMaterials,
      }
    )
    setLoadingArchiveOrderItems(false)
    setArchiveOrderConfirmationModel(false)
    if (resInstance.data.error) {
      toast.error(resInstance.data.error)
    } else if (resInstance?.data.warning) {
      setSelectedMaterials([])
      setSelectedOrderItems([])
      setReload(true)
      toast.warning(resInstance?.data.warning)
    } else if (resInstance?.status < 300) {
      setSelectedMaterials([])
      setSelectedOrderItems([])
      if (props.setReload) {
        props.setReload(true)
      }
    } else {
      toast.error('Error archiving order items.')
    }
  }

  function selectedDifferentSupplier() {
    let suppliers = {}

    orderItems
      ?.filter((oi) => !oi.is_buyer_marketplace_fee)
      .forEach((oi) => {
        selectedMaterials?.forEach((selectedMaterial) => {
          if (oi?.id === selectedMaterial && oi?.supplier?.id) {
            suppliers[oi?.supplier?.id] = true
          }
        })
      })
    return Object.keys(suppliers).length > 1
  }

  const handleAddTruckClose = () => {
    setAddTruckModal(false)
    setSelectedCargoUnitId()
    setSelectedPickupLocationId()
    setSelectedDeliveryLocationId()
    setNumberOfTrucks(1)
    setOrderItems((prevState) => {
      return prevState.map((oi) => ({
        ...oi,
        selected_delivery_quantity: null,
      }))
    })
  }

  return (
    <div id="materials-list" style={{ padding: '5px 20px 20px 20px' }}>
      {addPurchaseOrderModal && (
        <AddPurchaseOrder
          supplier={orderItems[0]?.supplier}
          orderItems={!purchaseOrder && selectedOrderItems}
          order={order}
          setReload={(_) => {
            setReloadAdminOrder(true)
            setPurchaseOrder()
          }}
          setOuterPurchaseOrder={setPurchaseOrder}
          update={purchaseOrder}
          purchaseOrderId={purchaseOrder?.id}
          openAddPurchaseOrderModal={addPurchaseOrderModal}
          setOpenAddPurchaseOrderModal={setAddPurchaseOrderModal}
        />
      )}

      {/* Secondary Actions Row - Left-aligned grey buttons */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          gap: '8px',
          marginBottom: '8px',
          marginTop: '-10px',
        }}
      >
        {hasPermission(user, 'Create Document') && (
          <Popup
            id={'send-document-popup'}
            on={'click'}
            position={'bottom right'}
            style={{
              '--primaryColor': tenant?.deployment_primary_color,
              '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
            }}
            open={sendDocumentPopup}
            onOpen={() => setSendDocumentPopup(true)}
            onClose={() => setSendDocumentPopup(false)}
            offset={[-40, 30]}
            trigger={
              <Button
                basic
                className="send-document-button"
                color={'grey'}
                disabled={!selectedMaterials || selectedMaterials?.length === 0}
                style={{
                  '--primaryColor':
                    !selectedMaterials || selectedMaterials?.length === 0
                      ? '#A1A1A1'
                      : tenant?.deployment_primary_color,
                  '--secondaryButtonColor':
                    env.REACT_APP_SECONDARY_BUTTON_COLOR,
                }}
                content={'Send Document'}
                onClick={() => {
                  setSendDocumentPopup(true)
                }}
              />
            }
          >
            <PopupContent>
              <List>
                {globalSettings?.id && !globalSettings?.hide_rfq && (
                  <List.Item
                    style={{
                      '--primaryColor': tenant?.deployment_primary_color,
                    }}
                    disabled={
                      !selectedMaterials || selectedMaterials?.length === 0
                    }
                    onClick={() => {
                      setSendDocumentPopup(false)
                      setAddRFQModal(true)
                    }}
                  >
                    <PaperPlaneTilt size={20} weight="bold" />
                    <b>RFQ</b>
                  </List.Item>
                )}
                <List.Item
                  style={{
                    '--primaryColor': tenant?.deployment_primary_color,
                  }}
                  disabled={
                    !selectedMaterials || selectedMaterials?.length === 0
                  }
                  onClick={() => {
                    setSendDocumentPopup(false)
                    setAddInvoiceOrderModal(true)
                  }}
                >
                  <PaperPlaneTilt size={20} weight="bold" />
                  <b>Invoice</b>
                </List.Item>
                <List.Item
                  style={{
                    '--primaryColor': tenant?.deployment_primary_color,
                  }}
                  disabled={
                    !selectedMaterials || selectedMaterials?.length === 0
                  }
                  onClick={() => {
                    setSendDocumentPopup(false)
                    setAddPurchaseOrderModal(true)
                  }}
                >
                  <PaperPlaneTilt size={20} weight="bold" />
                  <b>Purchase Order</b>
                </List.Item>
                <List.Item
                  style={{
                    '--primaryColor': tenant?.deployment_primary_color,
                  }}
                  disabled={
                    !selectedMaterials || selectedMaterials?.length === 0
                  }
                  onClick={() => {
                    setSendDocumentPopup(false)
                    setAddSalesOrderModal(true)
                  }}
                >
                  <PaperPlaneTilt size={20} weight="bold" />
                  <b>Sales Order</b>
                </List.Item>
                <List.Item
                  style={{
                    '--primaryColor': tenant?.deployment_primary_color,
                  }}
                  disabled={
                    !selectedMaterials || selectedMaterials?.length === 0
                  }
                  onClick={() => {
                    setSendDocumentPopup(false)
                    setAddOrderInfoSheetModal(true)
                  }}
                >
                  <PaperPlaneTilt size={20} weight="bold" />
                  <b>Order Information Sheet</b>
                </List.Item>
              </List>
            </PopupContent>
          </Popup>
        )}

        {selectedDifferentSupplier() &&
          hasPermission(user, 'Create Fulfillment') && (
            <Popup
              trigger={
                <Button
                  basic
                  disabled={
                    !selectedMaterials || selectedMaterials?.length === 0
                  }
                  color={'grey'}
                  style={{
                    '--primaryColor':
                      !selectedMaterials || selectedMaterials?.length === 0
                        ? '#A1A1A1'
                        : tenant?.deployment_primary_color,
                    '--secondaryButtonColor':
                      env.REACT_APP_SECONDARY_BUTTON_COLOR,
                    opacity: 0.5,
                  }}
                  content={'Add Truck'}
                />
              }
              content={
                'Select only items from the same supplier in order to add new truck.'
              }
              position={'bottom'}
            />
          )}
        {!selectedDifferentSupplier() &&
          hasPermission(user, 'Create Fulfillment') && (
            <Button
              basic
              disabled={!selectedMaterials || selectedMaterials?.length === 0}
              color={'grey'}
              style={{
                '--primaryColor':
                  !selectedMaterials || selectedMaterials?.length === 0
                    ? '#A1A1A1'
                    : tenant?.deployment_primary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              }}
              content={'Add Truck'}
              onClick={() => {
                setAddTruckModal(true)
              }}
            />
          )}

        {hasPermission(user, 'Delete Material List') && (
          <Button
            basic
            disabled={!selectedMaterials || selectedMaterials?.length === 0}
            color={'grey'}
            style={{
              '--primaryColor':
                !selectedMaterials || selectedMaterials?.length === 0
                  ? '#A1A1A1'
                  : tenant?.deployment_primary_color,
              '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
            }}
            content={'Delete'}
            onClick={() => {
              setArchiveOrderConfirmationModel(true)
            }}
          />
        )}
      </div>

      <Segment basic style={{ padding: '0px', margin: '0px' }}>
        <ConfirmationModal
          message={'Are you sure you want to archive these items?'}
          confirmationModal={archiveOrderConfirmationModel}
          setConfirmationModal={setArchiveOrderConfirmationModel}
          loading={loadingArchiveOrderItems}
          yesFunction={() => archiveOrderItems()}
          noFunction={() => setArchiveOrderConfirmationModel(false)}
        />

        {(orderItems?.length <= 0 ||
          (orderItems?.length === 1 &&
            orderItems[0].is_buyer_marketplace_fee)) && (
          <MickeyPlaceholder
            style={{ margin: '20px', clear: 'right' }}
            iconHtml={<TextAlignLeft size={40} />}
            message={'No material added.'}
          />
        )}
        {orderItems?.length > 0 &&
          !(
            orderItems?.length === 1 && orderItems[0].is_buyer_marketplace_fee
          ) && (
            <MickeyTable
              headerRow={
                orderItem?.is_credit_line_item
                  ? [...itemsHeaderRow.slice(0, 4), ...itemsHeaderRow.slice(7)]
                  : itemsHeaderRow
              }
              basicSegment
              containerClassName={'materials-list-table'}
              loadedStyle={{ width: '100%' }}
              compact={'very'}
              collapsing
              sticky
              loaded={loading}
              data={orderItems}
              reload={reload}
              setReload={setReload}
              renderBodyRow={(data, index) => {
                return displayOrderItem(data) ? (
                  <AdminOrderItemsRow
                    index={index}
                    setPurchaseOrder={setPurchaseOrder}
                    setAddPurchaseOrderModal={setAddPurchaseOrderModal}
                    canEdit={
                      !order?.locked && !(order?.admin_order_status == 6)
                    }
                    order={order}
                    selectedMaterials={selectedMaterials}
                    onClick={(e, d) => {
                      if (data?.is_buyer_marketplace_fee) {
                        return
                      }
                      if (orderItem?.id === data?.id) {
                        setOrderItem(null)
                      } else {
                        setOrderItem(data)
                      }
                    }}
                    setSelectedMaterials={setSelectedMaterials}
                    setSelectedOrderItems={setSelectedOrderItems}
                    selectedOrderItems={selectedOrderItems}
                    orderCancelled={order?.admin_order_status == 6}
                    orderItems={orderItems}
                    orderItem={data}
                    supplier={supplier}
                    selectedOrderItem={orderItem}
                    setReload={setReload}
                    reload={reload}
                    setReloadAdminOrder={setReloadAdminOrder}
                    setOrderItem={(d) => {
                      let ois = [...orderItems]
                      ois[index] = {
                        ...d,
                        selected_sales_order_unit_of_measure: d.buyer_unit?.id,
                        selected_sales_order_quantity: d.buyer_quantity,
                        selected_invoice_quantity: d.buyer_quantity,
                        selected_invoice_unit_of_measure: d.buyer_unit?.id,
                      }
                      setOrderItems(ois)
                    }}
                    key={data ? data.id : null}
                    locked={order.locked}
                  />
                ) : null
              }}
              urlParams={{
                order_id: order?.id,
              }}
              emptyIconHtml={<TextAlignLeft size={40} />}
              footerRow={
                <Table.Row>
                  <Table.HeaderCell colSpan={'5'}>
                    <b>Totals</b>
                  </Table.HeaderCell>
                  <Table.Cell colSpan="1" warning>
                    <b>{formatTotalPrice(totalPrice)}</b>
                  </Table.Cell>
                  <Table.HeaderCell colSpan={'1'}></Table.HeaderCell>
                  <Table.HeaderCell colSpan="1"></Table.HeaderCell>
                  <Table.HeaderCell colSpan="1">
                    <b>{formatTotalPrice(totalTax)}</b>
                  </Table.HeaderCell>
                  <Table.Cell colSpan="1" positive>
                    {primaryPricing && (
                      <b>{formatTotalPrice(deliveredPrice)}</b>
                    )}
                    {!primaryPricing && (
                      <b>{formatTotalPrice(secondaryDeliveredPrice)}</b>
                    )}
                  </Table.Cell>
                  <Table.HeaderCell colSpan="2">
                    {primaryPricing && <b>{formatTotalPrice(totalTake)}</b>}
                    {!primaryPricing && (
                      <b>{formatTotalPrice(totalSecondaryTake)}</b>
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell colSpan="2"></Table.HeaderCell>
                </Table.Row>
              }
              emptyMessage={'Fulfillment will populate here'}
            />
          )}

        <Modal
          size={'large'}
          onClose={() => {
            setAddInvoiceOrderModal(false)
            setSelectedInvoiceMethod()
            setInvoiceNumber()
            setInvoiceShipVia('')
            setInvoiceFob('')
            setInvoiceRequisitioner('')
            setInvoiceExpectedShipDate('')
            setInvoicePaymentTerms('')
            setOrderItems((prevState) => {
              return prevState.map((oi) => ({
                ...oi,
                selected_invoice_quantity: oi.buyer_quantity,
                selected_invoice_unit_of_measure: oi.buyer_unit?.id,
              }))
            })
          }}
          onOpen={() => setAddInvoiceOrderModal(true)}
          open={addInvoiceOrderModal}
        >
          <Modal.Header>Create Invoice</Modal.Header>
          <Modal.Content>
            <Form>
              <Form.Group>
                <Popup
                  position={'bottom right'}
                  offset={[0, 0]}
                  content={
                    <div style={{ padding: '10px' }}>
                      <Header as={'h4'} content={'Invoice Only'} />
                      <p>
                        Select this option if you'd like to only send the
                        Invoice to the buyer. This is ideal if you're expecting
                        a check or already have payment methods determined.
                      </p>
                      <Header as={'h4'} content={'Mark Paid Externally'} />
                      <p>
                        Select this option if you collected payment outside the
                        Mickey app.
                      </p>
                    </div>
                  }
                  style={{ marginLeft: '5px' }}
                  on="hover"
                  pinned
                  trigger={
                    <Icon name={'info circle'} style={{ marginLeft: '7px' }} />
                  }
                />
                <Form.Field width={6}>
                  <Form.Dropdown
                    className={'invoice-dropdown'}
                    clearable
                    selection
                    placeholder={'Select Invoice Type'}
                    label={'Select Invoice Type'}
                    onChange={(e, d) => {
                      setSelectedInvoiceMethod(d.value)
                    }}
                    value={selectedInvoiceMethod}
                    style={{
                      minWidth: '70%',
                    }}
                    options={[
                      {
                        key: 'send-buyer-invoice',
                        value: 'Invoice Only',
                        text: 'Invoice Only',
                      },
                    ]}
                  />
                </Form.Field>
                {selectedInvoiceMethod === 'Invoice Only' && (
                  <Form.Field width={4}>
                    <label>Invoice Number</label>
                    <Form.Input
                      placeholder={'Invoice Number'}
                      value={invoiceNumber}
                      onChange={(e, d) => {
                        setInvoiceNumber(d.value)
                      }}
                    />
                  </Form.Field>
                )}
              </Form.Group>
              {selectedInvoiceMethod === 'Invoice Only' && (
                <>
                  <Form.Group widths={'equal'}>
                    <Form.Field>
                      <label>Ship Via</label>
                      <Form.Input
                        placeholder={'e.g., FedEx, UPS, Freight'}
                        value={invoiceShipVia}
                        onChange={(e, d) => setInvoiceShipVia(d.value)}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>F.O.B.</label>
                      <Form.Input
                        placeholder={'e.g., Origin, Destination'}
                        value={invoiceFob}
                        onChange={(e, d) => setInvoiceFob(d.value)}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Expected Ship Date</label>
                      <Form.Input
                        type={'date'}
                        value={invoiceExpectedShipDate}
                        onChange={(e, d) => setInvoiceExpectedShipDate(d.value)}
                      />
                    </Form.Field>
                  </Form.Group>
                  <Form.Group widths={'equal'}>
                    <Form.Field>
                      <label>Requisitioner</label>
                      <Form.Input
                        placeholder={'Requisitioner name'}
                        value={invoiceRequisitioner}
                        onChange={(e, d) => setInvoiceRequisitioner(d.value)}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>Payment Terms</label>
                      <Form.Dropdown
                        clearable
                        selection
                        placeholder={'Select Payment Terms'}
                        value={invoicePaymentTerms}
                        onChange={(e, d) => setInvoicePaymentTerms(d.value)}
                        options={[
                          { key: 'net15', value: 'Net 15', text: 'Net 15' },
                          { key: 'net30', value: 'Net 30', text: 'Net 30' },
                          { key: 'net45', value: 'Net 45', text: 'Net 45' },
                          { key: 'net60', value: 'Net 60', text: 'Net 60' },
                          { key: 'due-receipt', value: 'Due on Receipt', text: 'Due on Receipt' },
                          { key: 'cod', value: 'COD', text: 'COD' },
                        ]}
                      />
                    </Form.Field>
                    <Form.Field />
                  </Form.Group>
                </>
              )}
            </Form>

            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Product</Table.HeaderCell>
                  <Table.HeaderCell>Quantity</Table.HeaderCell>
                  <Table.HeaderCell>Unit of Measure</Table.HeaderCell>
                  <Table.HeaderCell>Price</Table.HeaderCell>
                  <Table.HeaderCell>Total</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {orderItems?.map((orderItem, index) => {
                  if (
                    orderItem?.is_buyer_marketplace_fee ||
                    (orderItem?.id &&
                      !selectedMaterials.includes(orderItem?.id))
                  )
                    return
                  let totalCCIQuantity
                  if (orderItem?.cargo_container_items?.length > 0) {
                    totalCCIQuantity = _.map(
                      orderItem?.cargo_container_items,
                      (cci) => {
                        return cci.quantity
                      }
                    )
                    totalCCIQuantity = _.reduce(
                      totalCCIQuantity,
                      (ci1, ci2) => {
                        return parseFloat(ci1) + parseFloat(ci2)
                      }
                    )
                    totalCCIQuantity = orderItem?.quantity - totalCCIQuantity
                  } else {
                    totalCCIQuantity = orderItem?.quantity
                  }
                  let mickeyTake = orderItem.mickey_take
                    ? orderItem.mickey_take
                    : 0
                  mickeyTake =
                    mickeyTake *
                    (parseFloat(orderItem?.selected_invoice_quantity) /
                      orderItem?.buyer_quantity)
                  return (
                    <Table.Row>
                      <Table.Cell>
                        <OrderItemDetailTwo orderItem={orderItem} />
                      </Table.Cell>
                      <Table.Cell>
                        {orderItem?.buyer_quantity}
                        {/* <Input */}
                        {/*   placeholder={'Quantity'} */}
                        {/*   error={ */}
                        {/*     parseFloat(orderItem?.selected_invoice_quantity) > */}
                        {/*       parseFloat(orderItem?.buyer_quantity) || */}
                        {/*     parseFloat(orderItem?.selected_invoice_quantity) < 0 */}
                        {/*   } */}
                        {/*   value={orderItem?.buyer_quantity} */}
                        {/*   defaultValue={orderItem?.quantity} */}
                        {/*   onChange={(e, d) => { */}
                        {/*     let sms = [...orderItems] */}
                        {/*     sms[index] = { */}
                        {/*       ...orderItem, */}
                        {/*       selected_invoice_quantity: d.value, */}
                        {/*     } */}
                        {/*     setOrderItems(sms) */}
                        {/*   }} */}
                        {/* /> */}
                      </Table.Cell>
                      <Table.Cell>
                        {orderItem?.buyer_unit?.plural_name}
                        {/* <MickeyDropdown */}
                        {/*   url={'/main/unit-of-measures/'} */}
                        {/*   name={'unit_of_measure'} */}
                        {/*   value={orderItem?.buyer_unit} */}
                        {/*   defaultValue={orderItem?.unit?.id} */}
                        {/*   params={{ */}
                        {/*     page_size: 25, */}
                        {/*     product_id: orderItem?.product_variant?.product_id, */}
                        {/*   }} */}
                        {/*   autoComplete="new-password" */}
                        {/*   placeholder={'Unit of Measure'} */}
                        {/*   titleFields={['plural_name']} */}
                        {/*   descriptionFields={[]} */}
                        {/*   onChange={(e, d) => { */}
                        {/*     let sms = [...orderItems] */}
                        {/*     sms[index] = { */}
                        {/*       ...orderItem, */}
                        {/*       buyer_unit: d.value, */}
                        {/*     } */}
                        {/*     setOrderItems(sms) */}
                        {/*   }} */}
                        {/* /> */}
                      </Table.Cell>
                      <Table.Cell>
                        {formatTotalPrice(orderItem?.secondary_delivered_price)}
                      </Table.Cell>
                      <Table.Cell>
                        {formatTotalPrice(
                          parseFloat(orderItem?.secondary_delivered_price) *
                            parseFloat(orderItem?.buyer_quantity)
                        )}
                      </Table.Cell>
                    </Table.Row>
                  )
                })}
              </Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell>
                    <b>Total</b>
                  </Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell>
                    <b>
                      {formatTotalPrice(
                        orderItems
                          ?.map((orderItem, index) => {
                            if (
                              orderItem?.is_buyer_marketplace_fee ||
                              (orderItem?.id &&
                                !selectedMaterials.includes(orderItem?.id))
                            )
                              return 0
                            let salesTax = orderItem.tax_amount
                              ? orderItem.tax_amount
                              : 0

                            return (
                              parseFloat(orderItem?.secondary_delivered_price) *
                                parseFloat(orderItem?.buyer_quantity) +
                              parseFloat(salesTax)
                            )
                          })
                          .reduce(
                            (accumulator, currentValue) =>
                              parseFloat(accumulator) +
                              parseFloat(currentValue),
                            0
                          )
                      )}
                    </b>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => {
                setAddInvoiceOrderModal(false)
                setSelectedInvoiceMethod()
                setInvoiceNumber()
                setOrderItems((prevState) => {
                  return prevState.map((oi) => ({
                    ...oi,
                    selected_invoice_quantity: oi.buyer_quantity,
                    selected_invoice_unit_of_measure: oi.buyer_unit?.id,
                  }))
                })
              }}
              color={'black'}
              style={{
                padding: '.75rem',
                borderRadius: '500px',
              }}
            >
              Cancel
            </Button>
            {selectedInvoiceMethod === 'Invoice Only' && (
              <>
                <Button
                  type="submit"
                  onClick={() => invoiceOnly(false)}
                  color="primary"
                  style={{
                    '--primaryColor': tenant?.deployment_primary_color,
                    '--secondaryColor': tenant?.deployment_secondary_color,
                    '--secondaryButtonColor':
                      env.REACT_APP_SECONDARY_BUTTON_COLOR,
                  }}
                >
                  Create
                </Button>
                <Button
                  type="submit"
                  onClick={() => invoiceOnly(true)}
                  color="primary"
                  icon="paper plane"
                  style={{
                    '--primaryColor': tenant?.deployment_primary_color,
                    '--secondaryColor': tenant?.deployment_secondary_color,
                    '--secondaryButtonColor':
                      env.REACT_APP_SECONDARY_BUTTON_COLOR,
                  }}
                >
                  Create & Send
                </Button>
              </>
            )}
          </Modal.Actions>
        </Modal>
        {addSalesOrderModal && (
          <AddSalesOrder
            buyer={orderItems[0]?.buyer}
            orderItems={!salesOrder && selectedOrderItems}
            order={order}
            setReload={(_) => {
              setReloadAdminOrder(true)
              setSalesOrder()
            }}
            setSalesOrder={setSalesOrder}
            update={salesOrder}
            salesOrderId={salesOrder?.id}
            openAddSalesOrderModal={addSalesOrderModal}
            setOpenAddSalesOrderModal={setAddSalesOrderModal}
          />
        )}
        {/* <Modal
        size={'large'}
        onClose={() => {
          setAddSalesOrderModal(false)
          setSalesOrderNumber()
          setOrderItems((prevState) => {
            return prevState.map((oi) => ({
              ...oi,
              selected_sales_order_quantity: oi.buyer_quantity,
              selected_sales_order_unit_of_measure: oi.buyer_unit?.id,
            }))
          })
        }}
        onOpen={() => setAddSalesOrderModal(true)}
        open={addSalesOrderModal}
      >
        <Modal.Header>Create Sales Order</Modal.Header>
        <Modal.Content>
          <Grid>
            <Grid.Row>
              <Grid.Column width={16}>
                <Form>
                  <Form.Group>
                    <Form.Field width={4}>
                      <label>Sales Order Number</label>
                      <Form.Input
                        placeholder={'Sales Order Number'}
                        value={salesOrderNumber}
                        onChange={(e, d) => {
                          setSalesOrderNumber(d.value)
                        }}
                      />
                    </Form.Field>
                    <Form.Field>
                      <label>
                        Shipping Location{' '}
                        <span style={{ color: 'indianred' }}> *</span>
                      </label>
                      <MickeyDropdown
                        placeholder={'Shipping Location'}
                        url={'/main/admin-locations/'}
                        name={'location'}
                        value={locationId}
                        params={{
                          supplier_id: supplier?.id,
                          purchase_order_id: purchaseOrder?.id,
                          page_size: 25,
                          admin_cargo_unit_instance_id: true,
                        }}
                        tenantAware={false}
                        titleFields={['name']}
                        descriptionFields={[
                          'address_1',
                          'city',
                          'state',
                          'zip_code',
                        ]}
                        onChange={(e, d) => setLocationId(d.value)}
                      />
                    </Form.Field>
                    <Form.Field width={4}>
                      <label>Ship Via</label>
                      <Form.Input
                        placeholder={'Ship Via'}
                        value={shipVia}
                        onChange={(e, d) => {
                          setShipVia(d.value)
                        }}
                      />
                    </Form.Field>
                    <Form.Field width={4}>
                      <label>Payment Terms</label>
                      <Form.Input
                        placeholder={'Payment Terms'}
                        value={paymentTerms}
                        onChange={(e, d) => {
                          setPaymentTerms(d.value)
                        }}
                      />
                    </Form.Field>
                  </Form.Group>
                </Form>
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Product</Table.HeaderCell>
                <Table.HeaderCell>Quantity</Table.HeaderCell>
                <Table.HeaderCell>Unit of Measure</Table.HeaderCell>
                <Table.HeaderCell>Price</Table.HeaderCell>
                <Table.HeaderCell>Mickey Take</Table.HeaderCell>
                <Table.HeaderCell>Total</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {orderItems?.map((orderItem, index) => {
                if (
                  orderItem?.is_buyer_marketplace_fee ||
                  (orderItem?.id && !selectedMaterials.includes(orderItem?.id))
                )
                  return
                const mickeyTake = orderItem.mickey_take
                  ? orderItem.mickey_take
                  : 0
                return (
                  <Table.Row>
                    <Table.Cell>
                      <OrderItemDetailTwo orderItem={orderItem} />
                    </Table.Cell>
                    <Table.Cell>
                      {orderItem?.buyer_quantity}
                      <Input
                        placeholder={'Quantity'}
                        error={
                          parseFloat(orderItem?.selected_sales_order_quantity) >
                            parseFloat(orderItem?.buyer_quantity) ||
                          parseFloat(orderItem?.selected_sales_order_quantity) <
                            0
                        }
                        value={orderItem?.selected_sales_order_quantity}
                        defaultValue={orderItem?.buyer_quantity}
                        onChange={(e, d) => {
                          let sms = [...orderItems]
                          sms[index] = {
                            ...orderItem,
                            selected_sales_order_quantity: d.value,
                          }
                          setOrderItems(sms)
                        }}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      {orderItem?.buyer_unit?.plural_name}
                      <MickeyDropdown
                        url={'/main/unit-of-measures/'}
                        name={'unit_of_measure'}
                        value={orderItem?.selected_sales_order_unit_of_measure}
                        defaultValue={orderItem?.unit?.id}
                        params={{
                          page_size: 25,
                          product_id: orderItem?.product_variant?.product_id,
                        }}
                        autoComplete="new-password"
                        placeholder={'Unit of Measure'}
                        titleFields={['plural_name']}
                        descriptionFields={[]}
                        onChange={(e, d) => {
                          let sms = [...orderItems]
                          sms[index] = {
                            ...orderItem,
                            selected_sales_order_unit_of_measure: d.value,
                          }
                          setOrderItems(sms)
                        }}
                      />
                    </Table.Cell>
                    <Table.Cell>
                      {formatTotalPrice(orderItem?.secondary_delivered_price)}
                    </Table.Cell>
                    <Table.Cell>
                      {formatTotalPrice(
                        mickeyTake *
                          (parseFloat(
                            orderItem?.selected_sales_order_quantity
                          ) /
                            orderItem?.buyer_quantity)
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {formatTotalPrice(
                        orderItem?.secondary_delivered_price *
                          orderItem?.buyer_quantity
                      )}
                    </Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell>
                  <b>Sales Tax</b>
                </Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell>
                  <b>
                    {formatTotalPrice(
                      orderItems
                        ?.map((orderItem, index) => {
                          if (
                            orderItem?.is_buyer_marketplace_fee ||
                            (orderItem?.id &&
                              !selectedMaterials.includes(orderItem?.id))
                          )
                            return 0
                          let salesTax = orderItem.tax_amount
                            ? orderItem.tax_amount
                            : 0
                          salesTax =
                            salesTax *
                            (parseFloat(
                              orderItem?.selected_sales_order_quantity
                            ) /
                              orderItem?.buyer_quantity)
                          return salesTax
                        })
                        .reduce(
                          (accumulator, currentValue) =>
                            parseFloat(accumulator) + parseFloat(currentValue),
                          0
                        )
                    )}
                  </b>
                </Table.HeaderCell>
              </Table.Row>
              <Table.Row>
                <Table.HeaderCell>
                  <b>Total</b>
                </Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell>
                  <b>
                    {formatTotalPrice(
                      orderItems
                        ?.map((orderItem, index) => {
                          if (
                            orderItem?.is_buyer_marketplace_fee ||
                            (orderItem?.id &&
                              !selectedMaterials.includes(orderItem?.id))
                          )
                            return 0
                          let salesTax = orderItem.tax_amount
                            ? orderItem.tax_amount
                            : 0
                          salesTax =
                            salesTax *
                            (parseFloat(
                              orderItem?.selected_sales_order_quantity
                            ) /
                              orderItem?.buyer_quantity)
                          let mickeyTake = orderItem.mickey_take
                            ? orderItem.mickey_take
                            : 0
                          mickeyTake =
                            mickeyTake *
                            (parseFloat(
                              orderItem?.selected_sales_order_quantity
                            ) /
                              orderItem?.buyer_quantity)
                          return (
                            parseFloat(orderItem?.secondary_delivered_price) *
                              parseFloat(orderItem?.buyer_quantity) +
                            parseFloat(salesTax)
                            parseFloat(mickeyTake)
                          )
                        })
                        .reduce(
                          (accumulator, currentValue) =>
                            parseFloat(accumulator) + parseFloat(currentValue),
                          0
                        )
                    )}
                  </b>
                </Table.HeaderCell>
              </Table.Row>
            </Table.Footer>
          </Table>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              setAddSalesOrderModal(false)
              setSalesOrderNumber()
              setOrderItems((prevState) => {
                return prevState.map((oi) => ({
                  ...oi,
                  selected_sales_order_quantity: oi.quantity,
                  selected_sales_order_unit_of_measure: oi.buyer_unit?.id,
                }))
              })
            }}
            color={'black'}
            style={{
              padding: '.75rem',
              borderRadius: '500px',
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            onClick={() => addSalesOrder(false)}
            color="primary"
            style={{
              '--primaryColor': tenant?.deployment_primary_color,
              '--secondaryColor': tenant?.deployment_secondary_color,
              '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
            }}
          >
            Create
          </Button>
          <Button
            type="submit"
            onClick={() => addSalesOrder(true)}
            icon="paper plane"
            color="primary"
            style={{
              '--primaryColor': tenant?.deployment_primary_color,
              '--secondaryColor': tenant?.deployment_secondary_color,
              '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
            }}
          >
            Create & Send
          </Button>
        </Modal.Actions>
      </Modal> */}
        <Modal
          size={'large'}
          onClose={() => {
            setAddBidOrderModal(false)
            setSelectedBidSign(null)
          }}
          onOpen={() => setAddBidOrderModal(true)}
          open={addBidOrderModal}
        >
          <Modal.Header>Create Bid</Modal.Header>
          <Modal.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <label style={{ color: 'black' }}>Select Document</label>
                  <Dropdown
                    placeholder={'Select Document'}
                    fluid
                    search
                    autoComplete="new-password"
                    selection
                    value={selectedBidSign}
                    options={[
                      { text: 'Bid', value: 'bid', key: 'bid' },
                      { text: 'Pre Bid', value: 'pre_bid', key: 'pre_bid' },
                    ]}
                    onChange={(e, d) => {
                      setSelectedBidSign(d.value)
                    }}
                  />
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Product</Table.HeaderCell>
                  <Table.HeaderCell>Buyer Quantity</Table.HeaderCell>
                  <Table.HeaderCell>Extended Quantity</Table.HeaderCell>
                  <Table.HeaderCell>Unit of Measure</Table.HeaderCell>
                  <Table.HeaderCell>Price</Table.HeaderCell>
                  <Table.HeaderCell>Mickey Take</Table.HeaderCell>
                  <Table.HeaderCell>Total</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {orderItems?.map((orderItem, index) => {
                  if (
                    orderItem?.is_buyer_marketplace_fee ||
                    (orderItem?.id &&
                      !selectedMaterials.includes(orderItem?.id))
                  )
                    return
                  const mickeyTake = orderItem.mickey_take
                    ? orderItem.mickey_take
                    : 0
                  return (
                    <Table.Row>
                      <Table.Cell>
                        <OrderItemDetailTwo orderItem={orderItem} />
                      </Table.Cell>
                      <Table.Cell>
                        {orderItem?.buyer_quantity}{' '}
                        <span style={{ color: '#999' }}>
                          {orderItem?.buyer_unit?.short_name}
                        </span>
                      </Table.Cell>
                      <Table.Cell>
                        {orderItem?.extended_quantity && orderItem?.extended_unit ? (
                          <>
                            {orderItem?.extended_quantity}{' '}
                            <span style={{ color: '#999' }}>
                              {orderItem?.extended_unit?.short_name}
                            </span>
                          </>
                        ) : (
                          <span style={{ color: '#ccc' }}>—</span>
                        )}
                      </Table.Cell>
                      <Table.Cell>
                        {orderItem?.buyer_unit?.plural_name}
                      </Table.Cell>
                      <Table.Cell>
                        {formatTotalPrice(orderItem?.secondary_delivered_price)}
                      </Table.Cell>
                      <Table.Cell>{formatTotalPrice(mickeyTake)}</Table.Cell>
                      <Table.Cell>
                        {formatTotalPrice(
                          orderItem?.secondary_delivered_price *
                            orderItem?.buyer_quantity +
                            parseFloat(mickeyTake)
                        )}
                      </Table.Cell>
                    </Table.Row>
                  )
                })}
              </Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell>
                    <b>Sales Tax</b>
                  </Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell>
                    <b>
                      {formatTotalPrice(
                        orderItems
                          ?.map((orderItem, index) => {
                            if (
                              orderItem?.is_buyer_marketplace_fee ||
                              (orderItem?.id &&
                                !selectedMaterials.includes(orderItem?.id))
                            )
                              return 0
                            return orderItem.tax_amount
                              ? orderItem.tax_amount
                              : 0
                          })
                          .reduce(
                            (accumulator, currentValue) =>
                              parseFloat(accumulator) +
                              parseFloat(currentValue),
                            0
                          )
                      )}
                    </b>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell>
                    <b>Total</b>
                  </Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell></Table.HeaderCell>
                  <Table.HeaderCell>
                    <b>
                      {formatTotalPrice(
                        orderItems
                          ?.map((orderItem, index) => {
                            if (
                              orderItem?.is_buyer_marketplace_fee ||
                              (orderItem?.id &&
                                !selectedMaterials.includes(orderItem?.id))
                            )
                              return 0
                            const salesTax = orderItem.tax_amount
                              ? orderItem.tax_amount
                              : 0
                            const mickeyTake = orderItem.mickey_take
                              ? orderItem.mickey_take
                              : 0
                            return (
                              parseFloat(orderItem?.delivered_price) *
                                parseFloat(orderItem?.buyer_quantity) +
                              parseFloat(salesTax) +
                              parseFloat(mickeyTake)
                            )
                          })
                          .reduce(
                            (accumulator, currentValue) =>
                              parseFloat(accumulator) +
                              parseFloat(currentValue),
                            0
                          )
                      )}
                    </b>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => {
                setAddBidOrderModal(false)
                setSelectedBidSign()
              }}
              color={'black'}
              style={{
                padding: '.75rem',
                borderRadius: '500px',
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!selectedBidSign}
              onClick={() => {
                if (selectedBidSign) {
                  addBidOrder(false)
                }
              }}
              color="primary"
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryColor': tenant?.deployment_secondary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              }}
            >
              Create
            </Button>
            <Button
              type="submit"
              disabled={!selectedBidSign}
              onClick={() => {
                if (selectedBidSign) {
                  addBidOrder(true)
                }
              }}
              icon="paper plane"
              color="primary"
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryColor': tenant?.deployment_secondary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              }}
            >
              Create & Send
            </Button>
          </Modal.Actions>
        </Modal>
        <Modal
          size={'large'}
          onClose={handleAddTruckClose}
          onOpen={() => setAddTruckModal(true)}
          open={addTruckModal}
        >
          <Modal.Header>Add Truck</Modal.Header>
          <Modal.Content>
            <Grid columns={4}>
              <Grid.Row>
                <Grid.Column>
                  <label>Cargo Type</label>
                  <MickeyDropdown
                    url={'/main/cargo-units/'}
                    name={'cargo_unit'}
                    defaultValue={selectedCargoUnitId}
                    autoComplete="new-password"
                    label={'Cargo Type'}
                    tenantAware={false}
                    placeholder={'Select Cargo Type'}
                    titleFields={['singular_name']}
                    descriptionFields={[]}
                    onChange={(e, d) => {
                      setSelectedCargoUnitId(d.value)
                    }}
                  />
                </Grid.Column>
                <Grid.Column>
                  <label>Pickup Location</label>
                  <MickeyDropdown
                    url={'/main/admin-locations/'}
                    params={{
                      admin_order_item_id: orderItem?.id,
                      business_id: orderItems?.filter((orderItem) =>
                        selectedMaterials.includes(orderItem?.id)
                      )[0]?.supplier?.business?.id,
                      is_pickup: true,
                    }}
                    name={'pickup_location'}
                    defaultValue={selectedPickupLocationId}
                    autoComplete="new-password"
                    tenantAware={false}
                    label={'Pickup Address'}
                    placeholder={'Select Pickup Address'}
                    titleFields={['name', 'address_1']}
                    descriptionFields={['city', 'state', 'zip_code']}
                    onChange={(e, d) => {
                      setSelectedPickupLocationId(d.value)
                    }}
                  />
                </Grid.Column>
                <Grid.Column>
                  <label>Delivery Location</label>
                  <MickeyDropdown
                    url={'/main/admin-locations/'}
                    params={{
                      admin_order_item_id: orderItem?.id,
                      business_id: props.order?.buyer?.business?.id,
                      is_delivery: true,
                    }}
                    name={'pickup_location'}
                    defaultValue={selectedDeliveryLocationId}
                    autoComplete="new-password"
                    tenantAware={false}
                    label={'Pickup Address'}
                    placeholder={'Select Pickup Address'}
                    titleFields={['name', 'address_1']}
                    descriptionFields={['city', 'state', 'zip_code']}
                    onChange={(e, d) => {
                      setSelectedDeliveryLocationId(d.value)
                    }}
                  />
                </Grid.Column>
                <Grid.Column>
                  <label>Number of Trucks</label>
                  <Input
                    type={'number'}
                    step={1}
                    min={1}
                    value={numberOfTrucks}
                    onChange={(e, d) => setNumberOfTrucks(d.value)}
                  />
                </Grid.Column>
              </Grid.Row>
              {globalSettings?.id && globalSettings?.disabled_quantity && (
                <Grid.Row>
                  <Grid.Column></Grid.Column>
                </Grid.Row>
              )}
            </Grid>
          </Modal.Content>
          <Modal.Actions className="add-truck-action">
            <Button onClick={handleAddTruckClose}>Cancel</Button>
            <Button
              type="submit"
              onClick={() => addTruck()}
              loading={addTruckButtonLoading}
              disabled={addTruckButtonLoading}
              color="primary"
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryColor': tenant?.deployment_secondary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              }}
            >
              Add Truck
            </Button>
          </Modal.Actions>
        </Modal>
        <Modal
          size={'large'}
          onClose={() => {
            setAddRFQModal(false)
            setSelectedSuppliers([])
            setSelectedBuyers([])
            setRfqNumber([])
          }}
          onOpen={() => setAddRFQModal(true)}
          open={addRFQModal}
        >
          <Modal.Header>Send RFQ</Modal.Header>
          <Modal.Content>
            <Grid>
              <Grid.Row>
                <Grid.Column width={4}>
                  <Form.Field>
                    <label>RFQ Number</label>
                    <Form.Input
                      name="rfq_number"
                      value={rfqNumber}
                      placeholder="RFQ Number"
                      onChange={(e, d) => {
                        setRfqNumber(d.value)
                      }}
                    />
                  </Form.Field>
                </Grid.Column>
                <Grid.Column width={6}>
                  <label>Select Suppliers</label>
                  <MickeyDropdown
                    multiple
                    selection
                    url={'/main/suppliers/'}
                    name={'suppliers'}
                    defaultValue={selectedSuppliers}
                    autoComplete="new-password"
                    label={'Select Suppliers'}
                    tenantAware={false}
                    placeholder={'Select Suppliers'}
                    titleFields={['business.name']}
                    descriptionFields={['']}
                    onChange={(e, d) => {
                      setSelectedSuppliers(d.value)
                    }}
                  />
                </Grid.Column>
                <Grid.Column width={6}>
                  <label>Select Buyers</label>
                  <MickeyDropdown
                    multiple
                    selection
                    url={'/main/buyers/'}
                    name={'buyers'}
                    defaultValue={selectedBuyers}
                    autoComplete="new-password"
                    label={'Select Buyers'}
                    tenantAware={false}
                    placeholder={'Select Buyers'}
                    titleFields={['business.name']}
                    descriptionFields={['']}
                    onChange={(e, d) => {
                      setSelectedBuyers(d.value)
                    }}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Products</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {orderItems?.map((orderItem, index) => {
                      if (
                        orderItem?.is_buyer_marketplace_fee ||
                        (orderItem?.id &&
                          !selectedMaterials.includes(orderItem?.id))
                      )
                        return null
                      return (
                        <Table.Row>
                          <Table.Cell>
                            <OrderItemDetailTwo orderItem={orderItem} />
                          </Table.Cell>
                        </Table.Row>
                      )
                    })}
                  </Table.Body>
                </Table>
              </Grid.Row>
            </Grid>
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => setAddRFQModal(false)}
              color={'black'}
              style={{
                padding: '.75rem',
                borderRadius: '500px',
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              onClick={() => sendRFQ(false)}
              color="primary"
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryColor': tenant?.deployment_secondary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              }}
            >
              Activate RFQ (No Email)
            </Button>
            <Button
              type="submit"
              onClick={() => sendRFQ(true)}
              color="primary"
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryColor': tenant?.deployment_secondary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              }}
            >
              Send RFQ Email
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal
          size={'large'}
          onClose={() => {
            setAddOrderInfoSheetModal(false)
          }}
          onOpen={() => setAddOrderInfoSheetModal(true)}
          open={addOrderInfoSheetModal}
        >
          <Modal.Header>Create Order Information Sheet</Modal.Header>
          <Modal.Content>
            <Table>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Product</Table.HeaderCell>
                  <Table.HeaderCell>Quantity</Table.HeaderCell>
                  <Table.HeaderCell>Unit of Measure</Table.HeaderCell>
                  <Table.HeaderCell>Price</Table.HeaderCell>
                  <Table.HeaderCell>Total</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {orderItems?.map((orderItem, index) => {
                  if (
                    orderItem?.is_buyer_marketplace_fee ||
                    (orderItem?.id &&
                      !selectedMaterials.includes(orderItem?.id))
                  )
                    return null
                  return (
                    <Table.Row>
                      <Table.Cell>
                        <OrderItemDetailTwo orderItem={orderItem} />
                      </Table.Cell>
                      <Table.Cell>{orderItem?.buyer_quantity}</Table.Cell>
                      <Table.Cell>
                        {orderItem?.buyer_unit?.plural_name}
                      </Table.Cell>
                      <Table.Cell>
                        {formatTotalPrice(orderItem?.secondary_delivered_price)}
                      </Table.Cell>
                      <Table.Cell>
                        {formatTotalPrice(
                          orderItem?.secondary_delivered_price *
                            orderItem?.buyer_quantity
                        )}
                      </Table.Cell>
                    </Table.Row>
                  )
                })}
              </Table.Body>
            </Table>
          </Modal.Content>
          <Modal.Actions>
            <Button
              onClick={() => setAddOrderInfoSheetModal(false)}
              color={'black'}
              style={{
                padding: '.75rem',
                borderRadius: '500px',
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              onClick={() => addOrderInfoSheet(false)}
              color="primary"
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryColor': tenant?.deployment_secondary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              }}
            >
              Create
            </Button>
            <Button
              type="submit"
              onClick={() => addOrderInfoSheet(true)}
              color="primary"
              icon="paper plane"
              style={{
                '--primaryColor': tenant?.deployment_primary_color,
                '--secondaryColor': tenant?.deployment_secondary_color,
                '--secondaryButtonColor': env.REACT_APP_SECONDARY_BUTTON_COLOR,
              }}
            >
              Create & Send
            </Button>
          </Modal.Actions>
        </Modal>
      </Segment>
    </div>
  )
}

export default AdminOrderMaterialsList
